// src/pages/ContactUsPage.jsx
import React from "react";

const ContactUsPage = () => {
  return (
    <div className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 text-center mb-12 font-inter drop-shadow-md">
          Get in Touch with Insperity Games
        </h1>

        <section className="bg-white p-10 rounded-3xl shadow-xl mb-12 border-t-4 border-blue-500">
          <p className="text-gray-700 text-xl leading-relaxed mb-8">
            We love hearing from our players and partners! Whether you have a
            question about one of our games, need technical support, have a
            business inquiry, or just want to say hello, feel free to reach out.
          </p>
          <p className="text-gray-700 text-xl leading-relaxed mb-10">
            We strive to respond to all inquiries as quickly as possible.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
            <div className="flex flex-col items-center text-center p-8 bg-blue-50 rounded-2xl shadow-md transform hover:scale-105 transition-transform duration-300">
              <i className="fas fa-headset text-blue-700 text-6xl mb-5 animate-pulse"></i>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 font-inter">
                General Inquiries & Player Support
              </h2>
              <p className="text-gray-800 mb-3 text-lg">
                For game questions or technical issues:
              </p>
              <a
                href="mailto:insperitygames@gmail.com"
                className="text-blue-700 hover:text-blue-900 font-semibold text-xl transition-colors duration-200"
              >
                insperitygames@gmail.com
              </a>
              <p className="text-sm text-gray-500 mt-3">
                (Please include game name & device type for support)
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-8 bg-teal-50 rounded-2xl shadow-md transform hover:scale-105 transition-transform duration-300">
              <i className="fas fa-briefcase text-teal-700 text-6xl mb-5 animate-pulse delay-100"></i>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 font-inter">
                Business & Partnership Inquiries
              </h2>
              <p className="text-gray-800 mb-3 text-lg">
                For collaborations and business proposals:
              </p>
              <a
                href="mailto:business.insperitygames@gmail.com"
                className="text-teal-700 hover:text-teal-900 font-semibold text-xl transition-colors duration-200"
              >
                business.insperitygames@gmail.com
              </a>
            </div>
          </div>

          <div className="text-center mt-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-6 font-inter">
              Connect With Us Online
            </h2>
            <div className="flex justify-center space-x-8 text-5xl">
              <a
                href="#"
                className="text-blue-700 hover:text-blue-500 transition-colors duration-200 transform hover:scale-110"
              >
                <i className="fab fa-facebook-square"></i>
              </a>
              <a
                href="#"
                className="text-blue-400 hover:text-blue-200 transition-colors duration-200 transform hover:scale-110"
              >
                <i className="fab fa-twitter-square"></i>
              </a>
              <a
                href="#"
                className="text-blue-800 hover:text-blue-600 transition-colors duration-200 transform hover:scale-110"
              >
                <i className="fab fa-linkedin"></i>
              </a>
              <a
                href="#"
                className="text-red-700 hover:text-red-500 transition-colors duration-200 transform hover:scale-110"
              >
                <i className="fab fa-youtube-square"></i>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactUsPage;
